import React, { useMemo, useState } from "react";
import styles from "./styles.module.css";
import TweetEmbed from "./TweetEmbed";
import normolizeTweetsData from "./normolizeTweetsData";
import normolizeBootcampToReviews from "./normolizeBootcampToReviews";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const TwitterReviews = (props) => {
  const {
    tweetsData,
    bootcampToReviews,
    content = "all",
    bgColor = "var(--black)",
    isBacklight = true,
    autoScrollEnabled = true,
  } = props;

  const currentData =
    content === "all" ||
    !bootcampToReviews ||
    !normolizeBootcampToReviews(bootcampToReviews)[content]
      ? normolizeTweetsData(tweetsData)
      : normolizeBootcampToReviews(bootcampToReviews)[content].map(
          (nick) =>
            normolizeTweetsData(tweetsData).find(
              (review) => review.nick === nick
            ) || normolizeTweetsData(tweetsData)[0]
        );
  const [reviews, setReviews] = useState(currentData);

  const extensions = useMemo(() => (autoScrollEnabled ? { AutoScroll } : {}), [
    autoScrollEnabled,
  ]);

  const options = useMemo(
    () => ({
      type: "loop",
      autoWidth: true,
      autoScroll: {
        type: "loop",
        drag: "free",
        focus: "center",
        perPage: 3,
        autoScroll: {
          speed: 10,
        },
      },
    }),
    []
  );

  return (
    <div style={{ backgroundColor: bgColor }} className={styles.reviewsWrapper}>
      <Splide
        extensions={extensions}
        options={options}
        aria-label="Twitter review"
      >
        {reviews.map((info, index) => (
          <SplideSlide>
            <div key={index} className={styles.review}>
              <a target="_blank" href={info.link}>
                <TweetEmbed {...info} isBacklight={isBacklight} />
              </a>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default TwitterReviews;
